import styled from "styled-components";


export const SectionContainer = styled.div`
    display: flex;
    gap: 2rem;
    width: 95%;
    max-width: 1350px;
    margin: 1rem auto;
    background-color: #fff;
    padding: 1.625rem 3.125rem;
    border-radius: .5rem;
`;

export const CompanyDataContainer = styled.div`
    position: relative;
    width: 30%;
    min-width: 16rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const CompanyDescriptionContainer = styled.div`
    position: relative;
    width: 70%;
    display: flex;
`;